import {
  FETCH_AGENCIES_REQUEST,
  FETCH_AGENCIES_SUCCESS,
  FETCH_AGENCIES_FAILURE,
  FETCH_AGENCY_REQUEST,
  FETCH_AGENCY_SUCCESS,
  FETCH_AGENCY_FAILURE,
  UPDATE_AGENCIES_REQUEST,
  UPDATE_AGENCIES_FAILURE,
  UPDATE_AGENCIES_SUCCESS,
  DELETE_AGENCIES_REQUEST,
  DELETE_AGENCIES_FAILURE,
  DELETE_AGENCIES_SUCCESS,
  FETCH_AGENCIES_RELEASE_REQUEST,
  FETCH_AGENCIES_RELEASE_SUCCESS,
  FETCH_AGENCIES_RELEASE_FAILURE,
  CLEAR_AGENCY_ERRORS,    // Nouvelles imports
  CLEAR_AGENCY_SUCCESS,
} from './actionTypes';

const initialState = {
  agencies: [],
  agenciesRelease: [],
  agency: null,
  loadingAgency: false,
  errorAgency: null,
  agencyAdded: null
};

const Agencies = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_AGENCIES_REQUEST:
      return {
        ...state,
        loadingAgency: true,
        errorAgency: null,
        agencyAdded: false
      };
    case FETCH_AGENCIES_SUCCESS:
      return {
        ...state,
        loadingAgency: false,
        agencies: action.payload.data,
      };
    case FETCH_AGENCIES_FAILURE:
      return {
        ...state,
        loadingAgency: false,
        errorAgency: action.payload,
      };
    case FETCH_AGENCIES_RELEASE_REQUEST:
      return {
        ...state,
        loadingAgency: true,
        errorAgency: null,
        agencyAdded: false
      };
    case FETCH_AGENCIES_RELEASE_SUCCESS:
      return {
        ...state,
        loadingAgency: false,
        agenciesRelease: action.payload.data,
      };
    case FETCH_AGENCIES_RELEASE_FAILURE:
      return {
        ...state,
        loadingAgency: false,
        errorAgency: action.payload,
      };
    case FETCH_AGENCY_REQUEST:
      return {
        ...state,
        loadingAgency: true,
        errorAgency: null,
        agencyAdded: false
      };
    case FETCH_AGENCY_SUCCESS:
      return {
        ...state,
        loadingAgency: false,
        agency: action.payload.data,
      };
    case FETCH_AGENCY_FAILURE:
      return {
        ...state,
        loadingAgency: false,
        errorAgency: action.payload,
      };
    case UPDATE_AGENCIES_REQUEST:
      return {
        ...state,
        loadingAgency: true,
        errorAgency: null,
        agencyAdded: false
      };
    case UPDATE_AGENCIES_SUCCESS:
      return {
        ...state,
        loadingAgency: false,
        agency: null,
        agencyAdded: true
      };
    case UPDATE_AGENCIES_FAILURE:
      return {
        ...state,
        loadingAgency: false,
        errorAgency: action.payload,
      };
    case DELETE_AGENCIES_REQUEST:
      return {
        ...state,
        loadingAgency: true,
        errorAgency: null,
        agencyAdded: false
      };
    case DELETE_AGENCIES_SUCCESS:
      return {
        ...state,
        agencyAdded: true,
        loadingAgency: false,
        agencies: state.agencies.filter(agency => agency.id !== action.payload),
      };
    case DELETE_AGENCIES_FAILURE:
      return {
        ...state,
        loadingAgency: false,
        errorAgency: action.payload,
      };
    case CLEAR_AGENCY_ERRORS:
      return {
        ...state,
        errorAgency: null,
      };
    case CLEAR_AGENCY_SUCCESS:
      return {
        ...state,
        agencyAdded: null,
      };
      
    default:
      return state;
  }
};

export default Agencies;